const API_URL_BASE = 'https://skifterhaender.com/_db/wp-json/wp/v2';
const htmlElem = document.querySelector('html');
const bodyElem = htmlElem.querySelector('body');
const contentElem = htmlElem.querySelector('.content');

const site = {
    size: {
        'mobile': 1,
        'tablet': 768,
        'desktop': 1024
    }
}

export {
    API_URL_BASE,
    htmlElem,
    bodyElem,
    contentElem,
    site
}